import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
import MaterialsPage from './pages/MaterialsPage';
import PromptGuidePage from './pages/PromptGuidePage';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen bg-white">
          <Toaster position="top-right" />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/materials" element={<MaterialsPage />} />
            <Route path="/guia-prompting" element={<PromptGuidePage />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;